let promise

export default function (slideshowId) {
  if (promise) {
    return promise
  }

  let resolve, reject

  promise = new Promise((resolveFn, rejectFn) => {
    resolve = resolveFn
    reject = rejectFn
  })

  const placeholder = document.getElementById("scribd_recs")
  if (!placeholder) {
    reject("no rec container")
    return promise
  }

  if (!placeholder.dataset.async) {
    resolve(placeholder)
    return promise
  }

  const testOverrides = new URLSearchParams()
  const url = new URL(document.location)
  for (let [key, value] of url.searchParams.entries()) {
    if (key.startsWith("ab_test[")) {
      testOverrides.append(key, value)
    }
  }

  fetch(`/slideshow/scribd_recs/${slideshowId}?${testOverrides}`, {
    credentials: "same-origin",
  })
    .then((response) => {
      if (!response.ok) {
        console.log("failed to load recs")
        throw new Error("failed to load recs")
      }

      return response.text()
    })
    .then((html) => {
      placeholder.innerHTML = html
      resolve(placeholder)
      if (amplitude) {
        const identity = new amplitude.Identify()
        for (let node of placeholder.querySelectorAll("[data-nway-test-name]")) {
          identity.set(node.dataset.nwayTestName, node.dataset.nwayTestValue)
        }
        amplitude.getInstance().identify(identity)
      }
    })

  return promise
}
